import React from 'react'
import { FaTimes } from 'react-icons/fa'
export default function Close(){
    return(
        <React.Fragment>
            <div className="close" onClick={()=>window.location.reload()}><FaTimes/></div>
        </React.Fragment>
    )
}